import {Component} from '@angular/core';
import {StateService} from '../../state.service';
import {Field} from '../../model/field.model';
import {TruffleFound} from '../../model/truffelFound.model';
import {ActivatedRoute} from '@angular/router';
import {Tree} from '../../model/tree.model';
import {calculateYearlyYield, inferStartYear} from '../../utils/yield.utils';

@Component({
    selector: 'app-field-view',
    templateUrl: './field-view.component.html',
    styleUrls: ['./field-view.component.css'],
    standalone: false
})
export class FieldViewComponent {

  fields: Field[] = [];
  fieldNames: string[] = [];
  selectedField: string;
  availableYears: number[] = [];
  selectedYear: number = new Date().getFullYear();

  constructor(public stateService: StateService, public route: ActivatedRoute) {
    this.fields = stateService.fields;
    this.fieldNames = this.fields.map(f => f.name);
    this.buildAvailableYears();

    this.route.paramMap.subscribe(params => {
      if (params.get('fieldId')) {
        this.selectedField = params.get('fieldId');
      }
    });
  }

  getSum(truffleFounds: TruffleFound[]) {
    return truffleFounds.reduce((acc, cur) => acc + Number(cur.weight), 0);
  }

  hasYieldForYear(tree: Tree, year: number) {
    if (!tree.truffleFounds || !tree.truffleFounds.length) {
      return false;
    }
    return tree.truffleFounds.some(found => {
      const foundYear = new Date(found.foundAt).getFullYear();
      return foundYear <= year && Number(found.weight) > 0;
    });
  }

  getTreeTooltip(lineId: number, tree: Tree) {
    const base = `R:${lineId} B:${tree.id} ${tree.treeType ?? ''}`;
    const total = `${this.getSum(tree.truffleFounds)}g`;
    const startYear = inferStartYear(tree.createdAt, undefined, tree.truffleFounds);
    const yearly = calculateYearlyYield(tree.truffleFounds, startYear)
      .map(entry => `${entry.year}: ${entry.weight}g`)
      .join('\n');
    return yearly ? `${base} ${total}\n${yearly}` : `${base} ${total}`;
  }

  private buildAvailableYears() {
    const years = new Set<number>([this.selectedYear]);
    this.fields.forEach(field => {
      field.lines?.forEach(line => {
        line.trees?.forEach(tree => {
          tree.truffleFounds?.forEach(found => {
            const year = new Date(found.foundAt).getFullYear();
            if (!Number.isNaN(year)) {
              years.add(year);
            }
          });
        });
      });
    });
    this.availableYears = Array.from(years).sort((a, b) => b - a);
    if (!this.availableYears.includes(this.selectedYear)) {
      this.selectedYear = this.availableYears[0] ?? new Date().getFullYear();
    }
  }
}
